import { ChangeDetectionStrategy, Component, ViewEncapsulation } from "@angular/core";
import { CoreUiInteractionEvent, UiInteraction } from "@obg/ngx.core";
import { TrackingContext } from "@obg/ngx.ui.core";

import { FooterConfigService } from "../footer.config";

@Component({
	selector: "obg-footer-license",
	templateUrl: "./footer-license.component.html",
	styleUrls: ["./footer-license.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class FooterLicenseComponent {
	licenses = this.config.getLicenceKeys();
	licensesKey = "footer.licenses";
	licensesTrackingData: UiInteraction = {
		context: TrackingContext.FooterInteractionContext,
		event: CoreUiInteractionEvent.Navigate,
		data: {
			ItemClicked: this.licensesKey,
		},
	};
	expandedKeys = this.config.isLicenceTabExpanded() ? [this.licensesKey] : [];

	constructor(private config: FooterConfigService) {}
}
